


































































































































import OSS from "ali-oss";
import { getOSSConfig } from "@/api/ossImageUploader";
import audioPlay from "./audioPlay.vue";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import teachingMaterial from "./teachingMaterial.vue";
@Component({
  name: "uploadBox",
  components: {
    audioPlay,
    teachingMaterial,
  },
})
export default class extends Vue {
  client = null;
  prefix = "";
  cdn_url = "";
  callback = {};
  piclist = [];
  disabled = false;
  dialogVisible = false;
  dialogVideo = false;
  dialogImageUrl = "";
  dialogVideoUrl = "";
  textarea = "";
  progressNumber = 0;
  loading = false;
  imgLoading = false;
  audioLoading = false;
  content_list: any[] = [];
  videoUrl = [];
  musicUrl = [];
  created() {
    this.addText();
  }
  addText() {
    const _t = this as any;
    _t.content_list.push({ annex_type: 3, annex_content: "" });
  }
  changeinput() {
    const _t = this as any;
    _t.setData();
  }
  exceedClick(e: any) {
    this.$message({
      type: "error",
      message: "最多只上传9个!",
    });
  }
  play(e: any) {
    const _t = this as any;
    if (e.annex_type == 1) {
      _t.dialogImageUrl = e.url;
      _t.dialogVisible = true;
    } else if (e.annex_type == 2) {
      _t.dialogVideoUrl = e.url;
      _t.dialogVideo = true;
    }
  }
  del(e: any, item: any) {
    const _t = this as any;
    if (item.annex_type == 1) {
      const pictureUploadList = _t.$refs.imgUpload.uploadFiles;
      pictureUploadList.forEach((a: any, b: any) => {
        if (a.uid == item.uid) {
          pictureUploadList.splice(b, 1);
        }
      });
    } else if (item.annex_type == 2) {
      const videoUploadList = _t.$refs.videoUpload.uploadFiles;
      videoUploadList.forEach((a: any, b: any) => {
        if (a.uid == item.uid) {
          videoUploadList.splice(b, 1);
        }
      });
    } else if (item.annex_type == 4) {
      const musicUploadList = _t.$refs.musicUpload.uploadFiles;
      musicUploadList.forEach((a: any, b: any) => {
        if (a.uid == item.uid) {
          musicUploadList.splice(b, 1);
        }
      });
    }
    _t.content_list.splice(e, 1);
    _t.setData();
  }
  handleAddHomework(data: any) {
    data.content_list.map((item: any) => {
      item.url = item.annex_content;
    });
    this.content_list = [...this.content_list, ...data.content_list];
    this.setData();
  }
  setData() {
    const _t = this as any;
    let content_list = [];
    content_list = _t.content_list.map((a: any, b: number) => {
      a.sort = b;
      return a;
    });
    _t.$emit("setContentList", content_list);
  }
  chooseImg(e: any) {
    const self = this as any;
    getOSSConfig().then((res: any) => {
      // 注意前缀路径prefix的值每次请求token时都会改变，所以同一个上传请求不需要重新请求token，实现覆盖上传
      // 不同上传请求则需要每次重新获取token
      if (res.error_code == 0) {
        self.prefix = res.data.object_name_prefix;
        self.cdn_url = res.data.cdn_url;
        self.callback = res.data.callback;
        self.client = new OSS({
          accessKeyId: res.data.access_key_id,
          accessKeySecret: res.data.access_key_secret,
          stsToken: res.data.security_token,
          region: "oss-cn-shenzhen",
          bucket: res.data.bucket,
        });
        const progress = (p: any, _checkpoint: any) => {
          self.progressNumber = Math.floor(p * 100);
        };
        self.imgLoading = true;
        self.client
          .put(self.prefix + e.file.name, e.file, {
            callback: {
              url: self.callback.callback_url,
              host: self.callback.callback_host,
              body: self.callback.callback_body,
              contentType: self.callback.callback_body_type,
            },
            progress,
          })
          .then(function (result: any) {
            if (result.data.code == "Ok") {
              self.imageUrl = self.cdn_url + "/" + result.data.object;
              self.content_list.push({
                annex_type: 1,
                annex_content: result.data.object,
                url: self.imageUrl,
                uid: e.file.uid,
              });
              // self.$emit("set-img-url", result);
              self.setData();
              self.imgLoading = false;
              self.$message({
                type: "success",
                message: "上传成功!",
              });
            }
          })
          .catch(function (err: any) {
            self.imgLoading = false;
          });
      }
    });
  }
  beforeMusicUpload(file: any) {
    const _t = this as any;
    const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
    const extension =
      testmsg === "wav" || testmsg === "flac" || testmsg === "mp3";
    if (!extension) {
      this.$message.error("音频上传格式支持wav、falc、mp3；其他不支持");
      return false;
    }
    // const isLt2M = file.size / 1024 / 1024 < 5;
    // if (!isLt2M) {
    //   this.$message.error("上传图片大小不能超过 5MB!");
    // }
    return true;
  }
  beforeAvatarUpload(file: any) {
    const _t = this as any;
    const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
    const extension =
      testmsg === "jpg" ||
      testmsg === "JPG" ||
      testmsg === "png" ||
      testmsg === "PNG" ||
      testmsg === "jpeg" ||
      testmsg === "JPEG";
    if (!extension) {
      this.$message.error("图片上传格式支持jpeg、jpg、png；其他不支持");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 15;
    if (!isLt2M) {
      this.$message.error("上传图片大小不能超过 15MB!");
    }
    return isLt2M;
  }
  beforeVideoUpload(file: any) {
    const _t = this as any;
    const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
    const extension =
      testmsg === "MP4" ||
      testmsg === "mp4" ||
      testmsg === "mov" ||
      testmsg === "MOV";
    if (!extension) {
      this.$message.error("视频上传格式支持MP4、mov；其他不支持");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 500;
    if (!isLt2M) {
      this.$message.error("上传视频大小不能超过 500MB!");
      return false;
    }
  }
  handlePictureCardPreview(file: any) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
  chooseVideo(e: any) {
    const self = this as any;
    getOSSConfig().then(async (res: any) => {
      // 注意前缀路径prefix的值每次请求token时都会改变，所以同一个上传请求不需要重新请求token，实现覆盖上传
      // 不同上传请求则需要每次重新获取token
      if (res.error_code == 0) {
        self.cdn_url = res.data.cdn_url;
        const client = new OSS({
          accessKeyId: res.data.access_key_id,
          accessKeySecret: res.data.access_key_secret,
          stsToken: res.data.security_token,
          region: "oss-cn-shenzhen",
          bucket: res.data.bucket,
        });
        const progress = (p: any, _checkpoint: any) => {
          self.progressNumber = Math.floor(p * 100);
        };
        self.loading = true;
        try {
          // object-name可以定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至Bucket根目录或Bucket下的指定目录。
          const fname = res.data.object_name_prefix + e.file.name;
          const result = await client.multipartUpload(fname, e.file, {
            callback: {
              url: res.data.callback.callback_url,
              host: res.data.callback.callback_host,
              body: res.data.callback.callback_body,
              contentType: res.data.callback.callback_body_type,
            },
            progress,
            // partSize: 50*1024*1024,
            // meta是用户自定义的元数据，通过head接口可以获取到Object的meta数据。
            meta: {},
          });
          const head = await client.head(result.data.object);
          if (result.data.code == "Ok") {
            self.videoUrl = self.cdn_url + "/" + result.data.object;
            self.content_list.push({
              annex_type: 2,
              annex_content: result.data.object,
              url: self.videoUrl,
              uid: e.file.uid,
            });
            self.setData();
            self.$message({
              type: "success",
              message: "上传成功!",
            });
          } else {
            self.$message({
              type: "error",
              message: "上传失败",
            });
          }
          self.loading = false;
        } catch (e) {
          // 捕获超时异常。
          // console.log("TimeoutError");
          self.$message({
            type: "error",
            message: "上传超时",
          });
          // do ConnectionTimeoutError operation
          self.loading = false;
        }
      }
    });
  }
  chooseMusic(e: any) {
    const self = this as any;
    getOSSConfig().then(async (res: any) => {
      // 注意前缀路径prefix的值每次请求token时都会改变，所以同一个上传请求不需要重新请求token，实现覆盖上传
      // 不同上传请求则需要每次重新获取token
      if (res.error_code == 0) {
        self.cdn_url = res.data.cdn_url;
        const client = new OSS({
          accessKeyId: res.data.access_key_id,
          accessKeySecret: res.data.access_key_secret,
          stsToken: res.data.security_token,
          region: "oss-cn-shenzhen",
          bucket: res.data.bucket,
        });
        const progress = (p: any, _checkpoint: any) => {
          self.progressNumber = Math.floor(p * 100);
        };
        self.audioLoading = true;
        try {
          // object-name可以定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至Bucket根目录或Bucket下的指定目录。
          const fname = res.data.object_name_prefix + e.file.name;
          const result = await client.multipartUpload(fname, e.file, {
            callback: {
              url: res.data.callback.callback_url,
              host: res.data.callback.callback_host,
              body: res.data.callback.callback_body,
              contentType: res.data.callback.callback_body_type,
            },
            progress,
            // partSize: 50*1024*1024,
            // meta是用户自定义的元数据，通过head接口可以获取到Object的meta数据。
            meta: {},
          });
          // console.log(result);
          const head = await client.head(result.data.object);
          // console.log(head);
          if (result.data.code == "Ok") {
            self.musicUrl = self.cdn_url + "/" + result.data.object;
            self.content_list.push({
              annex_type: 4,
              annex_content: result.data.object,
              url: self.musicUrl,
              uid: e.file.uid,
            });
            self.setData();
            self.$message({
              type: "success",
              message: "上传成功!",
            });
          } else {
            self.$message({
              type: "error",
              message: "上传失败",
            });
          }
          self.audioLoading = false;
        } catch (e) {
          self.$message({
            type: "error",
            message: "上传超时",
          });
          self.audioLoading = false;
        }
      }
    });
  }
}
